import {Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

/**
 * Vérifie si l'url d'une image existe ou non.
 * Si elle n'existe pas, on la remplace par un placeholder
 * Fonctionne que l'url soit broken, null ou undefined
 * Dans le HTML : <img checkurl [src]="URL_DE_LELEMENT" alt="">
 */

@Directive({
    selector: '[checkurl]',
    standalone: true,
})
export class CheckImageUrlDirective {

  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) { }

  @HostListener('error') onError() {
    this.renderer.setAttribute(this.el.nativeElement, 'src', 'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/assets/pictures_coming_soon.png');
  }
}
